import {isLegacyItem}              from "@Common/logic/item/is-legacy-item";
import {cc}                        from "@Common/react/callback-chain";
import {cs}                        from "@Common/react/chain-services";
import {scopedState}               from "@Common/react/scoped-state";
import {UseState}                  from "@Common/react/use-state";
import {changeNestedValue}         from "@Common/utils/arr-path";
import {chain}                     from "@Common/utils/fs";
import {equalDeep, keepOnly, omit} from "@Common/utils/objects";

import {setCurrentToSaved} from "./set-current-to-saved";

export const PaperTypeLogic = ({item, templateOptions, method, next: rootNext}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            (() => {
                if (!item || isLegacyItem(item)) {
                    return null;
                }
                const paperTypeO = item.selections?.options?.find((o) => o.dev_key === "paper_type");
                const finishingO = item.selections?.options?.find((o) => o.group === "Finishing");
                return ({
                    paperTypeId: paperTypeO?.id,
                    finishing: paperTypeO && finishingO ? (
                        keepOnly(finishingO, ["id", "dev_key"])
                    ) : (
                        {type: "none"}
                    ),
                });
            })(),
            (v) => ({
                saved  : v,
                current: v,
            }),
        ),
        next,
    })],
    ["paperTypes", (_, next) => next(getPaperTypesFromMethod({method, templateOptions}))],
    ["paperType", ({state, paperTypes}, next) => next(cc([
        (_, next) => (
            state.value.current?.paperTypeId != null ? (
                paperTypes.find((o) => state.value.current.paperTypeId == o.id) ?? next()
            ) : (
                next()
            )
        ),
        () => getDefaultPaperType({paperTypes}),
    ]))],

    ["finishingTypes", ({paperType}, next) => next(paperType?.subOptions)],

    ["finishing", ({state, finishingTypes}, next) => next(
        !finishingTypes ? (
            null
        ) : state.value.current?.finishing ? (
            state.value.current.finishing.type === "none" ? (
                null
            ) : (
                finishingTypes.find((o) => (
                    o.id === state.value.current.finishing.id &&
                    o.dev_key === state.value.current.finishing.dev_key &&
                    true
                ))
            )
        ) : (
            finishingTypes[0]?.required ? (
                finishingTypes[0]
            ) : !templateOptions.defaultCoatingType || templateOptions.defaultCoatingType === "none" ? (
                null
            ) : (
                (finishingTypes.find((o) => o.dev_key === templateOptions.defaultCoatingType && sideMatches(templateOptions.defaultCoatingSide, o))) ||
                finishingTypes[0]
            )
        )
    )],


    ["step1", ({paperType}, next) => rootNext({
        paperType,

        cleanItem: (item) => changeNestedValue(item, ["selections", "options"], (_) => _?.filter((o) =>
            o.dev_key !== "paper_type" &&
            o.group !== "Finishing"
        )),
        next,
    })],

    ({
         step1, paperTypes, paperType, finishingTypes, finishing, state,
    }) => step1.next({
        state: scopedState(state, ["current"]),
        paperTypes, paperType, finishing, finishingTypes,

        itemEditor: {
            $name: "paper type",
            changed: !equalDeep(state.value.saved, state.value.current),
            prepareSave: (item) => ({
                newValue: changeNestedValue(item, ["selections", "options"], (_) => [
                    ..._ ?? [],
                    ...paperType ? [omit(paperType, ["productPrice", "subOptions", "distributionFilter"])] : [],
                    ...finishing ? [finishing] : [],
                ]),
                onSaved: () => setCurrentToSaved(state),
            }),
            valid: true,
        },
    }),
);

export const getPaperTypesFromMethod = ({templateOptions, method}) => (
    method === "download" ? cc([
        (_, next) => {
            const o = templateOptions.options.find((o) => (
                o.dev_key === "paper_type" &&
                o.name === "ELECTRONIC" &&
                o.distributionFilter.includes(method)
            ));
            if (o) {
                return [o];
            }
            return next();
        },
        () => {
            // Force use default paper type here even if it's not ELECTRONIC
            const o = templateOptions.options.find((o) => (
                o.dev_key === "paper_type" &&
                o.default
            ));
            if (o) {
                return [{
                    ...o,
                    productPrice: {
                        download: o.productPrice?.download ?? [{min:1,max:1, price:0}]
                    },
                }];
            }
            return [];
        },
    ]) : (
        templateOptions.options.filter((o) =>
            o.dev_key === "paper_type" && o.distributionFilter.includes(method)
        )
    )
)

export const getDefaultPaperType = ({paperTypes}) => paperTypes.find((o) => o.default) ?? paperTypes[0]

export const sideMatches = (defaultCoatingSide, o) => {
    if (!defaultCoatingSide)
        return false;
    switch (defaultCoatingSide) {
        case "side1":
            return o.id === '1'
        case "side2":
            return o.id === '2'
        case "both":
            return o.id === '3'
        default:
            return false;
    }
}
